/* src/app/components/my-order/my-order.component.scss */
:host {
  display: block;
  height: 100%;
}
.main-row {
  height: 100%;
}
.main-col {
  height: 100%;
}
ion-card {
  height: 100%;
  margin: 0;
  border-radius: 16px;
  box-shadow: none;
  word-break: break-word;
  --color: var(--color-black);
  background: transparent;
  padding: 15px 5px;
  text-transform: uppercase;
  overflow: auto;
}
ion-card ion-card-content {
  border-top: 1px solid var(--color-black);
  padding: 10px 0px;
}
ion-card ion-card-content:first-of-type {
  border: none;
}
.border-bottom {
  border-bottom: 1px solid var(--color-black) !important;
}
.border-top {
  border-top: 1px solid var(--color-black) !important;
}
ion-col {
  color: var(--color-black);
  font-family: AppFont, sans-serif;
  text-align: right;
  font-size: 12px;
  text-transform: uppercase;
}
ion-col.header {
  text-align: center;
  font-family: AppFont, sans-serif;
  font-size: 16px;
  color: var(--color-black);
  text-transform: uppercase;
}
ion-col div {
  text-align: left;
  color: #C1C1C1;
  text-transform: uppercase;
}
ion-col h3 {
  text-transform: uppercase;
  font-size: 14px;
  color: var(--color-black);
  text-align: left;
}
ion-col h3.right-col {
  text-align: right;
}
.your-order-title {
  text-transform: uppercase;
  color: var(--color-black);
}
.header {
  font-size: 20px;
}
ion-chip {
  background: #E2DCD5;
  color: var(--color-black);
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  font-size: 11px;
}
.reorder-section {
  display: flex;
  justify-content: flex-end;
}
.reorder {
  color: var(--color-black);
  color: white !important;
  padding: 5px 10px;
  width: fit-content;
  border-radius: 16px;
  cursor: pointer;
  z-index: 99;
}
.delivery-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.delivery-info .btn {
  color: var(--color-black);
  padding: 8px 15px;
  border-radius: 16px;
  color: white;
}
.reorder-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: fit-content;
}
.reorder-section .reorder {
  background: var(--ion-color-primary);
  border-radius: 26px;
  width: fit-content !important;
}
.reorder-section .reorder:hover {
  background: var(--primary-btn);
}
.disabled {
  opacity: 0.5;
}
/*# sourceMappingURL=my-order.component.css.map */
